import webClient from "../config/api.config";
import { AdminUserFilters } from "../types/adminUser.definition";

/** MED-1341: admin account directory; blank filters are left out of the query. */
export function searchAdminUsers(
  filters: AdminUserFilters,
  page: number,
  size: number
) {
  return webClient.request({
    method: "get",
    url: "/admin/users",
    params: {
      keyword: filters.keyword || undefined,
      role: filters.role || undefined,
      status: filters.status || undefined,
      created_from: filters.createdFrom || undefined,
      created_to: filters.createdTo || undefined,
      page,
      size,
    },
  });
}

/** Soft delete: the account is disabled, never removed. */
export function disableUser(id: number) {
  return webClient.request({
    method: "delete",
    url: `users/${id}`,
  });
}
